'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ReturnsLayout-module_pageWrapper__ia1yN{overflow-x:hidden}.ReturnsLayout-module_stepWrapper__8DIwQ{box-sizing:border-box;margin:0 auto;max-width:952px;min-height:calc(100vh - 250px);padding:0 .25rem}@media screen and (min-width:768px){.ReturnsLayout-module_desktopHeightWrapper__5rL4B{min-height:calc(100vh - 250px)}}";
var styles = {"pageWrapper":"ReturnsLayout-module_pageWrapper__ia1yN","stepWrapper":"ReturnsLayout-module_stepWrapper__8DIwQ","desktopHeightWrapper":"ReturnsLayout-module_desktopHeightWrapper__5rL4B"};
styleInject["default"](css_248z, 'bc57b670-3c22-4e1a-b5bf-4af43569a010');

exports["default"] = styles;
